import React, { useEffect, useState } from 'react';
import '../styles/InstallPWA.css';

const InstallPWA = () => {
  const [installState, setInstallState] = useState('checking'); // checking, not-supported, can-install, installed
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    // Check if already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                        window.navigator.standalone ||
                        document.referrer.includes('android-app://');

    if (isStandalone) {
      setInstallState('installed');
      return;
    }

    // Check if PWA is supported
    if (!('serviceWorker' in navigator)) {
      setInstallState('not-supported');
      return;
    }

    // Listen for the install prompt
    const handler = (e) => {
      e.preventDefault();
      setPromptInstall(e);
      setInstallState('can-install');
    };

    window.addEventListener('beforeinstallprompt', handler);

    // If we haven't received the prompt after 3 seconds, assume it's not supported
    const timeout = setTimeout(() => {
      if (installState === 'checking') {
        setInstallState('not-supported');
      }
    }, 3000);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      clearTimeout(timeout);
    };
  }, [installState]);

  const onClick = async (evt) => {
    evt.preventDefault();
    if (!promptInstall) return;

    promptInstall.prompt();
    const { outcome } = await promptInstall.userChoice;
    if (outcome === 'accepted') {
      setInstallState('installed');
    }
  };

  // Don't show anything if we're still checking or if PWA is not supported
  if (installState === 'checking' || installState === 'not-supported') {
    return null;
  }

  const buttonText = installState === 'installed' ? '📱 App Installed' : '📱 Add to Home Screen';
  const buttonStyle = {
    opacity: installState === 'installed' ? 0.7 : 1,
    cursor: installState === 'installed' ? 'default' : 'pointer'
  };

  return (
    <button
      className="install-button"
      onClick={installState === 'can-install' ? onClick : undefined}
      style={buttonStyle}
      disabled={installState === 'installed'}
      aria-label={buttonText}
    >
      {buttonText}
      {installState === 'installed' && (
        <small style={{ fontSize: '10px', display: 'block' }}>
          Thanks for installing!
        </small>
      )}
    </button>
  );

  return (
    <button
      className="install-button"
      onClick={onClick}
      aria-label="Install app"
    >
      📱 Add to Home Screen
    </button>
  );
};

export default InstallPWA;
